<template>
    <div v-if="flash?.message && !hide"
         class="alert alert-custom fade show shadow-sm mt-3"
         :class="[alertTypeClass]"
         role="alert">
        <div class="alert-icon">
            <i v-if="flash.type === 'error'" class="fas fa-bolt"/>
            <i v-else-if="flash.type === 'warning'" class="fas fa-exclamation-circle"/>
            <i v-else-if="flash.type === 'success'" class="fas fa-check-circle"/>
            <i v-else class="fas fa-info-circle"/>
        </div>
        <div class="alert-text">
            <div v-if="flash.title" class="text-2xl font-weight-light">
                {{ flash.title }}
            </div>
            <span v-html="flash.message"/>
        </div>
        <div class="alert-close">
            <button type="button" class="close" @click="hide = true">
                <span aria-hidden="true"><i class="ki ki-close"/></span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hide: false,
        };
    },

    computed: {
        flash() {
            return this.$page.props.flash;
        },

        alertTypeClass() {
            switch (this.flash.type) {
                case 'error':
                    return 'alert-light-danger';
                case 'warning':
                    return 'alert-light-warning';
                case 'success':
                    return 'alert-light-success';
                default:
                    return 'alert-light-info';
            }
        }
    },

    watch: {
        flash: {
            deep: true,
            handler(newValue, oldValue) {
                this.hide = false;
            }
        }
    }
};
</script>
